import './_product-form.scss';
import component from './product-form';

export default component;
